export const getDriverSafetyModalClassNames = () => {
    const isDarkModeEnabled = window.driveApp.store.getState().data.nightMode;
    return {
        driverSafetyModalTextFactorClassName: isDarkModeEnabled ? "driver-safety-modal-text__factor-darkmode" : "driver-safety-modal-text__factor",
        driverSafetyModalTextMessageClassName: isDarkModeEnabled ? "driver-safety-modal-text__message-darkmode" : "driver-safety-modal-text__message"
    };
};